/**
 * Bständig "Zuletzt angesehen" section
 *
 * Uses localStorage to build a running log of visited products.
 * On every PDP the current product is added to the front of the list;
 * the section then renders the *other* stored entries as cards.
 */
(function () {
  // v2: invalidates pre-"Auf Anfrage" caches that stored "0,00 €" for offline products.
  var STORAGE_KEY = 'bst.recentlyViewed.v2';
  var MAX_DEFAULT = 8;

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (err) {
      return [];
    }
  }

  function write(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (err) {
      /* ignore */
    }
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function cardMarkup(item) {
    var title = escapeHtml(item.title);
    var url = escapeHtml(item.url);
    var image = item.image ? escapeHtml(item.image) : '';
    var price = item.price ? escapeHtml(item.price) : '';
    var productId = escapeHtml(item.productId || '');
    var variantId = escapeHtml(item.variantId || '');
    var handle = escapeHtml(item.handle || '');
    var imgTag = image
      ? '<img src="' + image + '" alt="' + title + '" class="bst-card__image" loading="lazy">'
      : '<div class="bst-card__image-placeholder"></div>';
    return (
      '<div class="bst-card-wrapper card-wrapper product-card-wrapper" data-product-id="' + productId + '" data-product-handle="' + handle + '" data-variant-id="' + variantId + '">' +
      '  <a href="' + url + '" class="bst-card card card--standard card--media" aria-label="' + title + '">' +
      '    <div class="bst-card__image-wrapper"><div class="bst-card__image-canvas">' + imgTag + '</div></div>' +
      '    <div class="bst-card__info">' +
      '      <p class="bst-card__title">' + title + '</p>' +
      '      <hr class="bst-card__divider">' +
      '      <div class="bst-card__price">' + (price ? '<span class="bst-card__price-amount">' + price + '</span>' : '') + '</div>' +
      '    </div>' +
      '  </a>' +
      '</div>'
    );
  }

  function init() {
    var root = document.querySelector('[data-bst-recently-viewed]');
    if (!root) {
      // Even without a section on the current page, still log the visit
      // so other pages can pick it up.
    }

    var currentHandle = root ? root.getAttribute('data-current-handle') : '';
    var items = read();

    // Update the stored list with the current product (PDP only)
    if (currentHandle) {
      items = items.filter(function (it) { return it.handle !== currentHandle; });
      items.unshift({
        handle: currentHandle,
        productId: root.getAttribute('data-current-product-id'),
        title: root.getAttribute('data-current-title'),
        url: root.getAttribute('data-current-url'),
        image: root.getAttribute('data-current-image'),
        price: root.getAttribute('data-current-price'),
        variantId: root.getAttribute('data-current-variant-id'),
        ts: Date.now()
      });
      var max = parseInt(root.getAttribute('data-max-items') || MAX_DEFAULT, 10) || MAX_DEFAULT;
      items = items.slice(0, max + 1); // +1 because we filter out current below
      write(items);
    }

    if (!root) return;

    var renderItems = items.filter(function (it) { return it.handle !== currentHandle && it.url; });
    var track = root.querySelector('[data-bst-recently-viewed-track]');
    if (!track) return;
    if (!renderItems.length) {
      root.hidden = true;
      return;
    }

    track.innerHTML = renderItems
      .map(function (it) { return '<li class="bst-carousel__slide">' + cardMarkup(it) + '</li>'; })
      .join('');
    root.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
